export { default } from './AboutAppQuizStep';
